import * as React from 'react'

import { FlexProps, DOMRef, ScopedCSSRules } from '@dna/react-types'
// @ts-ignore
import { cx, css } from '@dna/core'
import { filterDOMProps, flexStyleProps, useStyleProps } from '../utils'

function Flex(props: FlexProps, ref: DOMRef<HTMLElement>) {
  let {
    UNSAFE_className,
    UNSAFE_style,
    as: ElementType = 'div',
    children,
    css: styleProps = {},
    ...otherProps
  } = props
  let {
    styleProps: { className, style },
  } = useStyleProps(
    {
      alignItems: 'stretch',
      flexDirection: 'column',
      display: 'flex',
      height: 'auto',
      justifyContent: 'flex-start',
      width: 'auto',
      ...styleProps,
      UNSAFE_className,
      UNSAFE_style,
    },
    flexStyleProps
  )

  return (
    <ElementType
      {...filterDOMProps(otherProps)}
      className={cx(css(style as ScopedCSSRules), className)}
      ref={ref}
    >
      {children}
    </ElementType>
  )
}

/**
 * A layout container using flexbox.
 * Provides DNA dimension values, and supports the gap property to define consistent spacing between items.
 *
 * @name
 * Flex
 *
 * @see
 * https://dna.telstrahealth.com/components/flex
 *
 * @example
 * <Flex gap="medium"></Flex>
 */
let _Flex = React.forwardRef(Flex)
export { _Flex as Flex }
